export default "__VITE_ASSET__CmjE8EfO__"